// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const postBinanceDeposit = async (amount: number | string) => {
  return await privateRequest.post(`${ConfEnv.API_WALLET.URL_BINANCE_DEPOSIT}`, {
    amount: amount.toString(),
  });
};

export const getBinanceTransactionStatus = async (orderId: string) => {
  return await privateRequest.get(
    `${ConfEnv.API_WALLET.URL_BINANCE_TRANSACTION_STATUS}/${encodeURIComponent(orderId)}`
  );
};
